import Vue from 'vue'

import RudderStackAdapter from './adapters/rudderstack-adapter'

let tracker = null

const TrackingPlugin = {
  install(Vue, { adapterInstance }) {
    try {
      const { TrackingQueue } = require('./tracking-queue')
      tracker = new TrackingQueue(adapterInstance)

      // Begin adapter initialization
      tracker.init()

      Vue.prototype.$track = {
        event: (...args) => tracker.trackEvent(...args),
        trackOnce: (...args) => tracker.trackEventOnce(...args),
        identify: (...args) => tracker.identify(...args),
        reset: () => tracker.reset(),
      }
    } catch (error) {
      console.error('Install TrackingPlugin failed', error)

      Vue.prototype.$track = {
        event: () => {
          console.warn('TrackingPlugin', 'event not ready')
        },
        identify: () => {
          console.warn('TrackingPlugin', 'identify not ready')
        },
      }
    }
  },
}

const buildTrackingPlugin = (locator) => {
  Vue.use(TrackingPlugin, {
    adapterInstance: new RudderStackAdapter(locator),
  })

  locator.tracking = Vue.prototype.$track
}

export { buildTrackingPlugin }
